/** Components */

import {Route, Routes} from "react-router-dom";
import {RecoilRoot} from "recoil";
import DigitalSign from "./digital-sign/DigitalSign";

/** Styles */

const ExternalNetworkMain = () => {
    return (
        <Routes>
            <Route path="/digital-sign" element={
                <RecoilRoot key={'digitalSign'}>
                    <DigitalSign/>
                </RecoilRoot>
            }/>
        </Routes>
    );
}

export default ExternalNetworkMain;
